import ApiRequest from '../util/ApiRequest'

export default class MemberBadge {
    getAll = async () => {
        return await ApiRequest.set('v1/member-badges', 'GET')
    }

    getByMemberID = async (member_id) => {
        return await ApiRequest.set(`v1/members/${member_id}/badges`, 'GET')
    }
}
